<template>
	<div>
		<BContainer>
			<h3>My Bookings</h3>
			<hr>
			<template v-if="!bookings.data.length">
				<BRow>
					<BCol>
						<p>
							No bookings to display.
						</p>
					</BCol>
				</BRow>
			</template>
			<template v-else>
				<h3>Active</h3>
				<template v-if="!activeBookings.length">
					<div class="text-muted">
						No active bookings to display.
					</div>
				</template>
				<template v-else>
					<BRow class="gap-y">
						<BCol v-for="booking in activeBookings" :key="booking.unique_id"
							lg="6">
							<booking :booking="booking" />
						</BCol>
					</BRow>
				</template>
				<div class="my-4"></div>
				<h3>Past</h3>
				<template v-if="!pastBookings.length">
					<div class="text-muted">
						No past bookings to display.
					</div>
				</template>
				<template v-else>
					<BCard>
						<BTable
							class="mb-0"
							hover
							selectable
							:items="pastBookings"
							:fields="[
								{ key: 'start_date', label: 'Start Date' },
								{ key: 'end_date', label: 'End Date' },
								{ key: 'frequency', label: 'Frequency' },
								{ key: 'service', label: 'Service' },
								{ key: 'address', label: 'Address' },
								{ key: 'status', label: 'Status' },
							]"
							@row-clicked="row => $router.push({ path: `/bookings/${row.unique_id}` })">
							<template #cell(start_date)="row">
								{{ formatDate(row.value) }}
							</template>
							<template #cell(end_date)="row">
								{{ formatDate(row.value) }}
							</template>
							<template #cell(frequency)="row">
								{{ row.value }} {{ pluralize('clean', row.value) }}
							</template>
							<template #cell(service)="row">
								{{ row.value }}
							</template>
							<template #cell(address)="row">
								{{ row.value }}
							</template>
							<template #cell(status)="row">
								<BBadge v-if="row.value === 'Cancelled'" variant="badge badge-danger">
									Cancelled
								</BBadge>
								<BBadge v-else-if="row.value === 'Completed'" variant="badge badge-success">
									Completed
								</BBadge>
							</template>
						</BTable>
					</BCard>
				</template>
			</template>
		</BContainer>
	</div>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import Booking from './Booking.vue';
	import { pluralize, formatDate } from '@js/utilities/index.js';

	export default {
		components: {
			Booking
		},
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				bookings: {
					data: [],
					meta: {}
				}
			}
		},
		computed: {
			activeBookings() {
				if (!this.bookings.data.length) return [];

				return this.bookings.data.filter(booking => {
					return booking.status === 'Accepted' || booking.status === 'Confirmed';
				});
			},
			pastBookings() {
				if (!this.bookings.data.length) return [];

				return this.bookings.data.filter(booking => {
					return booking.status === 'Cancelled' || booking.status === 'Completed';
				});
			}
		},
		async created() {
			await this.fetchBookings();
		},
		methods: {
			pluralize,
			formatDate,
			async fetchBookings() {
				await this.$axios.get('/api/client/bookings', {
					params: {
						status: ['Cancelled', 'Completed', 'Accepted', 'Confirmed'],
					}
				}).then(response => {
					this.bookings = response.data;
				}).catch(error => {
					this.handleError(error);
				})
			}
		},
	}
</script>
